<template>
    <div class="page-container">
        <!-- 顶部导航栏 -->
        <div class="nav-bar">
            <div class="nav-back" @click="onCancel">
                <span class="back-arrow">‹</span>
                <span class="back-text">返回</span>
            </div>
            <span class="nav-title">签名</span>
            <div class="nav-placeholder"></div>
        </div>

        <!-- 签名画布区域 -->
        <div class="signature-area">
            <canvas
                    ref="signatureCanvas"
                    class="signature-canvas"
                    @touchstart.prevent="onTouchStart"
                    @touchmove.prevent="onTouchMove"
                    @touchend.prevent="onTouchEnd"
                    @mousedown="onMouseDown"
                    @mousemove="onMouseMove"
                    @mouseup="onMouseUp"
                    @mouseleave="onMouseUp"
            ></canvas>
        </div>

        <!-- 提示文字 -->
        <div class="tip-text">
            请你在此手动签名自己的签名，签写操作完毕点击保存按钮
        </div>

        <!-- 底部操作区 -->
        <div class="bottom-bar">
            <div class="button-group">
                <button class="save-btn" @click="onSave">保存</button>
                <button class="clear-btn" @click="onClear">清除</button>
                <button class="cancel-btn" @click="onCancel">取消</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'signature',
        data() {
            return {
                canvasWidth: 0,
                canvasHeight: 0,
                isDrawing: false,
                hasSignature: false,
                canvas: null,
                ctx: null,
                dpr: 1,
                // 记录上一次坐标
                lastX: 0,
                lastY: 0
            }
        },
        mounted() {
            this.initCanvas()
        },
        methods: {
            // 初始化画布
            initCanvas() {
                const canvas = this.$refs.signatureCanvas
                if (!canvas) return

                const rect = canvas.getBoundingClientRect()
                this.canvasWidth = rect.width
                this.canvasHeight = rect.height

                // 设备像素比，解决高清屏模糊
                this.dpr = window.devicePixelRatio || 1
                const ctx = canvas.getContext('2d')

                // 放大画布尺寸，适配DPR
                canvas.width = this.canvasWidth * this.dpr
                canvas.height = this.canvasHeight * this.dpr
                ctx.scale(this.dpr, this.dpr)

                this.canvas = canvas
                this.ctx = ctx

                // 画笔样式
                ctx.strokeStyle = '#000000'
                ctx.lineWidth = 3
                ctx.lineCap = 'round'
                ctx.lineJoin = 'round'
            },

            // ========== 移动端触摸事件 ==========
            onTouchStart(e) {
                if (!this.ctx) return
                this.isDrawing = true
                const touch = e.touches[0]
                const pos = this.getCanvasPos(touch)
                this.lastX = pos.x
                this.lastY = pos.y
                this.ctx.beginPath()
                this.ctx.moveTo(pos.x, pos.y)
            },

            onTouchMove(e) {
                if (!this.ctx || !this.isDrawing) return
                const touch = e.touches[0]
                const pos = this.getCanvasPos(touch)
                this.ctx.lineTo(pos.x, pos.y)
                this.ctx.stroke()
                this.lastX = pos.x
                this.lastY = pos.y
                this.hasSignature = true
            },

            onTouchEnd() {
                this.isDrawing = false
                this.ctx?.closePath()
            },

            // ========== PC端鼠标事件 ==========
            onMouseDown(e) {
                if (!this.ctx) return
                this.isDrawing = true
                const pos = this.getCanvasPos(e)
                this.lastX = pos.x
                this.lastY = pos.y
                this.ctx.beginPath()
                this.ctx.moveTo(pos.x, pos.y)
            },

            onMouseMove(e) {
                if (!this.ctx || !this.isDrawing) return
                const pos = this.getCanvasPos(e)
                this.ctx.lineTo(pos.x, pos.y)
                this.ctx.stroke()
                this.lastX = pos.x
                this.lastY = pos.y
                this.hasSignature = true
            },

            onMouseUp() {
                this.isDrawing = false
                this.ctx?.closePath()
            },

            // 获取画布内相对坐标
            getCanvasPos(point) {
                const rect = this.canvas.getBoundingClientRect()
                return {
                    x: point.clientX - rect.left,
                    y: point.clientY - rect.top
                }
            },

            // 清除签名
            onClear() {
                if (!this.ctx) return
                this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)
                this.hasSignature = false
            },

            // 取消 返回上一页
            onCancel() {
                this.$router.go(-1)
            },

            // 保存签名
            async onSave() {
                if (!this.hasSignature) {
                    this.$toast && this.$toast('请先签名')
                    return
                }

                // 加载提示（根据你的UI框架自行替换）
                this.$toast('保存中...')

                try {
                    // canvas 转 base64
                    const base64 = this.canvas.toDataURL('image/jpeg', 0.8)
                    // base64 转 File 对象（用于上传）
                    const file = this.base64ToFile(base64, 'signature.jpg')

                    const res = await this.uploadFile(file)


                    if (res.state === 'SUCCESS' && res.normal) {
                        // 存入全局（Vue全局/状态管理）
                        localStorage.setItem('signatureUrl', res.normal);

                        this.$toast && this.$toast('签名保存成功')

                        // 返回两级页面
                        setTimeout(() => {
                            this.$router.go(-2)
                        }, 1500)
                    } else {
                        this.$toast && this.$toast('上传失败，请重试')
                    }
                } catch (err) {
                    this.$loading && this.$loading.hide()
                    this.$toast && this.$toast('保存失败，请重试')
                    console.error('保存签名失败：', err)
                }
            },

            // base64 转 File 文件
            base64ToFile(base64, fileName) {
                const arr = base64.split(',')
                const mime = arr[0].match(/:(.*?);/)[1]
                const bstr = atob(arr[1])
                let n = bstr.length
                const u8arr = new Uint8Array(n)
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n)
                }
                return new File([u8arr], fileName, {type: mime})
            },

            // 上传文件（替换为你项目的axios/request）
            uploadFile(file) {
                return new Promise((resolve, reject) => {
                    const uploadUrl = '/api-file/files/single2'

                    const formData = new FormData()
                    formData.append('file', file)

                    // 获取token
                    const token = localStorage.getItem('cgtoken') || ''

                    // 使用 axios 上传（Vue2 常用）
                    this.$axios({
                        method: 'post',
                        url: uploadUrl,
                        data: formData,
                        headers: {
                            'yxy-cg-token': token,
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                        .then(res => {
                            if (res.status === 200) {
                                resolve(res.data)
                            } else {
                                reject(new Error('上传状态码异常'))
                            }
                        })
                        .catch(err => {
                            reject(err)
                        })
                })
            }
        }
    }
</script>

<style scoped>
    .page-container {
        min-height: 100vh;
        background-color: #f5f5f5;
    }

    /* 导航栏 */
    .nav-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 44px;
        padding: 0 15px;
        background-color: #fff;
        border-bottom: 1px solid #eee;
    }

    .nav-back {
        display: flex;
        align-items: center;
        gap: 2.5px;
        cursor: pointer;
    }

    .back-arrow {
        font-size: 16px;
        color: #07c160;
    }

    .back-text {
        font-size: 14px;
        color: #07c160;
    }

    .nav-title {
        font-size: 16px;
        font-weight: 600;
        color: #333;
    }

    .nav-placeholder {
        width: 50px;
    }

    /* 签名区域 */
    .signature-area {
        margin: 15px;
        background-color: #f0f0f0;
        border-radius: 8px;
        overflow: hidden;
        height: 300px;
    }

    .signature-canvas {
        width: 100%;
        height: 100%;
        touch-action: none;
    }

    /* 提示文字 */
    .tip-text {
        padding: 10px 15px;
        text-align: center;
    }

    .tip-text {
        font-size: 12px;
        color: #ff0000;
        line-height: 1.6;
    }

    /* 底部操作区 */
    .bottom-bar {
        background-color: #fff;
        padding: 15px;
        /*padding-bottom: calc(15px + env(safe-area-inset-bottom));*/
    }

    .button-group {
        display: flex;
        gap: 10px;
    }

    .save-btn {
        flex: 1;
        height: 44px;
        line-height: 44px;
        background-color: #0066cc;
        color: #fff;
        font-size: 15px;
        font-weight: bold;
        border-radius: 22px;
        border: none;
        display: block;
        padding: 0;
        margin: auto;
    }

    .save-btn::after {
        border: none;
    }

    .clear-btn {
        flex: 1;
        height: 44px;
        line-height: 44px;
        background-color: #fff;
        color: #666;
        font-size: 15px;
        border-radius: 22px;
        border: 1px solid #ddd;
        display: block;
        padding: 0;
        margin: auto;
    }

    .clear-btn::after {
        border: none;
    }

    .cancel-btn {
        flex: 1;
        height: 44px;
        line-height: 44px;
        background-color: #fff;
        color: #666;
        font-size: 15px;
        border-radius: 22px;
        border: 1px solid #ddd;
        display: block;
        padding: 0;
        margin: auto;
    }

    .cancel-btn::after {
        border: none;
    }
</style>
